export default __webpack_public_path__ + "4128ca6d8af14c322082655106ee3b2f.png";